<template>
  <b-modal id="totalRecords"
           title = "Total Records vs Total with Phones"
           :ok-title = "okTitle"
           size="lg"
           :lazy="true"
           ok-only
            @shown="gettotalCount">
    <b-row>
      <b-col>
      <b-alert :show="alertDesc!==''" variant="warning">{{alertDesc}}</b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h3>Geo Breakdown</h3>
      </b-col>
      <b-col>
        <h3>Total Records with Phone</h3>
      </b-col>
      <b-col>
        <h3>Total Records</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        {{showdata.geo}}
      </b-col>
      <b-col>
        {{showdata.phonecount }}
      </b-col>
      <b-col>
        {{showdata.totalcount}}
      </b-col>
    </b-row>
    <m-loader v-show="responData === null && (this.geoItems.length !== 0 || this.$store.state.order.OrderAddresses.length !== 0)" size="smBox"/>
  </b-modal>
</template>

<script>
    export default {
      data () {
        return {
          okTitle: 'close',
          responData: null,
          alertDesc: ''
        }
      },
      computed: {
        geoItems () {
          return this.$store.getters['order/geoItems']
        },
        order () {
          return this.$store.state.order
        },
        showdata () {
          if (this.responData !== null) {
            return {geo: this.responData.OrderGeoName, phonecount: this.responData.PhoneCount[1].Count, totalcount: this.responData.PhoneCount[1].Count + this.responData.PhoneCount[0].Count}
          }
          return {geo: '', phonecount: 0, totalcount: 0}
        }
      },
      methods: {
        gettotalCount () {
          this.alertDesc = ''
          if (this.geoItems.length === 0 && this.$store.state.order.OrderAddresses.length === 0) {
            this.alertDesc = 'Please select at least one Geo Address'
            this.responData = null
            return
          }
          let that = this
          this.$http.post('PlaceOrder.aspx/GetPhoneResult', {
            order: this.$store.state.order
          }).then(resp => {
            if (resp.body.d.ResultFlag) {
              that.responData = resp.body.d.DataSource
            }
          })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/demo/MTotalRecords.vue